import React from "react";

import OurAppImage from "../assets/img/ourapp/ourApp.png";

const OurApp = () => {
  return (
    <div className="w-full flex flex-col gap-20 justify-around items-center lg:flex-row" id="app">
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-orange text-[36px] leading-tight lg:text-[60px] lg:leading-[98px] font-extrabold mb-4">
          Nosso App
        </h1>
        <p className="text-justify text-base lg:text-[18px] lg:leading-8 max-w-[540px] mb-8 p-5">
          Você pode ter acesso ao nosso app clicando no botão abaixo, faça seu
          registro e aproveite tudo o que temos a oferecer
        </p>

        <a href="https://drive.google.com/file/d/1IH0PmNkiEMw29l3Pnccqk5qMJRYDY46q/view?usp=sharing" target="_blank" rel="noreferrer">
          <button className="btn">Baixar App</button>
        </a>

        <div className="p-5">
          <p className="text-[10px] max-w-[400px] mt-10 text-orange/70 text-justify">
            Atenção: Ainda estamos em testes, bugs e maus funcionamentos podem
            ocorrer durante sua experiência no Inclusive Pet, por favor relate
            os mesmos para nossa equipe através do formulário abaixo.
          </p>
        </div>
      </div>

      <div className="flex justify-center mb-20">
        <img
          src={OurAppImage}
          alt="App illustration"
          className="h-200 lg:h-auto"
        />
      </div>
    </div>
  );
};

export default OurApp;
